import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormaPagoService } from '../../../services/forma-pago.service';
import { FormaPago } from '../../../models/forma-pago';
import { Validation } from '../../../config/validation';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { VentaService } from '../../../services/venta.service';
import { Venta } from '../../../models/venta';
import { CobroService } from '../../../services/cobro.service';
import { Cobro } from '../../../models/cobro';
import { CobroDetalle } from '../../../models/cobro_detalle';
import { SessionService } from '../../../services/session.service';
import { SweetMessage } from '../../../config/sweet-message';
import * as numeral from 'numeral';
import { Retencion } from '../../../models/retencion';
import { Cheque } from '../../../models/cheque';
import { Tarjeta } from '../../../models/tarjeta';
import * as moment from 'moment';
import { PlanAcumulativoService } from '../../../services/plan-acumulativo.service';
import { PlanAcumulativo } from '../../../models/plan-acumulativo';
import { ParametroService } from '../../../services/parametro.service';
import { DatosPagosComponent } from '../../../controls/datos-pago/datos-pago.component';
import { UtilsService } from '../../../services/utils.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ReporteModalComponent } from '../../modals/reporte-modal/reporte-modal.component';
import { Transferencia } from '../../../models/transferencia';
import { ParametroContabilidad } from '../../../models/parametro-contabilidad';
import { PeriodoContable } from '../../../models/periodo-contable';
import { PeriodoContableService } from '../../../services/periodo-contable.service';
import { ParametroContabilidadService } from '../../../services/parametro-contabilidad.service';
import { AsientoContable } from '../../../models/asiento-contable';
import { AsientoContableDetalle } from '../../../models/asiento-contable-detalle';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';

@Component({
	selector: 'cobro-add',
	templateUrl: './cobro-add.component.html',
    styleUrls: ['./cobro-add.component.css'],
    providers: [
        FormaPagoService,
        VentaService,
        CobroService,
        SessionService,
        PlanAcumulativoService,
        ParametroService,
        ParametroContabilidadService,
        PeriodoContableService
    ]
})
export class CobroAddComponent implements OnInit {
    public formasPago: Array<FormaPago>;
    public vl: Validation;
    public venta: Venta;
    public total_pago: number;
    public cambio: number;
    public cobro: Cobro;
    public msg: SweetMessage;
    public total_cobro: number;
    public loading = false;
    public plan:PlanAcumulativo;
    public cobros: Array<Cobro>;

    public cheques: Array<Cheque>;
    public tarjetas: Array<Tarjeta>;
    public transferencias: Array<Transferencia>;
    public valorefectivo: number;
    public fecha_cobro;
    public tipo : String;
    public numero_decimales: number;
    public format_decimal: String;
    public bsModalRef: BsModalRef;
    public guardado: boolean;
    public is_change_efectivo:boolean;
    public cobro_id: string;
    public cobro_grupo_id : string;
    public abonos: Array<any>;
    public Mod_Cartera: string;
	public Mod_Contabilidad: string;
    public parametrosContabilidad: Array<ParametroContabilidad>;
    public periodoContable: PeriodoContable;
    @ViewChild(DatosPagosComponent) datosPagos: DatosPagosComponent;
    public selectedRow: Number;
	constructor(
        public formaPagoService: FormaPagoService,
        private activatedRoute: ActivatedRoute,
        public ventaService: VentaService,
        public planAcumulativoService: PlanAcumulativoService,
        public cobroService: CobroService,
        public ss: SessionService,
        private parametroService: ParametroService,
        public utils: UtilsService,
        private modalService: BsModalService,
        
        private parametroContabilidadService: ParametroContabilidadService,
        private periodoContableService: PeriodoContableService,
    ) {
        this.formasPago = [];
        this.vl = new Validation();
        this.venta  = new Venta();
        this.cambio = 0;
        this.total_pago = 0;
        this.cobro = new Cobro();
        this.msg = new SweetMessage();
        this.total_cobro = 0;

        this.cheques = [];
        this.tarjetas = [];
        this.transferencias = [];
        this.valorefectivo = 0;
        this.fecha_cobro = moment(this.fecha_cobro);
        this.plan = new PlanAcumulativo();
        this.cobros = [];
        this.numero_decimales = 2;
        this.format_decimal = "0,0.00";
        this.guardado = false;
        this.is_change_efectivo = false;
        this.cobro_id = "";
        this.cobro_grupo_id = "";
        this.abonos = [];
        this.Mod_Cartera = this.ss.getData("mod_cartera");
        this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
        this.parametrosContabilidad = [];
		this.periodoContable = new PeriodoContable();
	}

	ngOnInit() {
        this.loading = true;
        let p1 = this.getParamNumeroDecimales();
        let p2 = this.getVenta();
        let p3 = null;
		if( this.Mod_Cartera && this.Mod_Contabilidad ) {
			p3 = this.getParametroContabilidadCobros();
		}
       // let p3 = this.getListadoAbonos(); 
        Promise.all([p1,p2,p3]).then(
            res => this.loading = false,
            err => this.loading = false
        );
    }

    getVenta(){
        return new Promise((resolve, reject) => {
            this.activatedRoute.params.forEach((params: Params) => {
                let tipo = params['tipo'];
                let id = params['id'];

                this.tipo = tipo;

                if( tipo == "VE" ){
                    let qs = '?embed=retencion,cliente,grupo?embed=cobro,amortizacion?embed=detalle&abono=true';
                    this.ventaService.getById(id, qs).subscribe(
                        res => {
                            this.total_cobro = 0;
                            this.venta = res.data;
                            
                            this.getListadoAbonos(); 
                            res.data.grupo.forEach(e => this.total_cobro += (e.cobro.recibido - e.cobro.cambio))
                        if( !this.venta.retencion ){
                            this.venta.retencion = new Retencion();
                        }
                            resolve();
                        },
                        err => {
                            this.cobros = [];
                            reject(err);
                        }
                    );
                }else if( tipo == "PA" ){
                    let qs = "?embed=tipocomprobante,cliente,grupo?embed=cobro";
                    this.planAcumulativoService.getById(id, qs).subscribe(
                        res => {
                            this.plan = res.data;
                
                            this.total_cobro = 0;
                           
                            res.data.grupo.forEach(e => this.total_cobro+= (e.cobro.recibido - e.cobro.cambio))
                            this.getListadoAbonos(); 
                            resolve();
                        },
                        err => {
                            this.cobros = [];
                            reject();
                        }
                    );
                }
            });
        });
    }

    numeroFactura(){
        return this.venta.serie + "-" + this.venta.punto_emision + "-" + this.venta.secuencial;
    }

    isFormValid(){
        if( this.fecha_cobro.toString().trim().length  === 0 ){
            return false;
        }
        if( this.total_pago < 0.01 ){
            return false;
        }
        if( this.total_pago <= 0 ){
            return false;
        }
        if( this.tipo == "VE" ){
            if( this.venta.estado_pago == "C" ){
                return false;
            }
        }else{
            if( this.plan.estado_pago == "C" ){
                return false;
            }
        }
        return true;
    }

    getParametroContabilidadCobros(){
        return new Promise((resolve, reject) => {
			// let qs = "?in[id]=9,11,16,17,18,20,22&embed=cuentacontable";
			let qs = "?tipo=V&in[seccion]=IM,C&embed=cuentacontable";
			this.parametroContabilidadService.getAll(qs).subscribe(
				res => {
					let is_confirmedParametros = true;
					this.parametrosContabilidad.forEach(parametroContabilidad => {
						if( parametroContabilidad.cuenta_contable_id == null ){
							is_confirmedParametros = false;
							return false;
						}
					});
					if(!is_confirmedParametros){
						this.msg.showMessage('error-message', "Por favor, confirmar los parámetros de las cuentas contables.");
					}else{
						this.parametrosContabilidad = res.data;
					}
					resolve(true);
				},
				err => {
					reject(err);
				}
			);
            
        });
    }

    setValueAsientoContable(){
        
       
        let asientoContableCobros = new AsientoContable();
        asientoContableCobros.fecha_emision = this.cobro.fecha_cobro;
        asientoContableCobros.tipo_comprobante_id = null;
        asientoContableCobros.periodo_contable_id = this.periodoContable.id;
        asientoContableCobros.numero_documento = null;
        asientoContableCobros.descripcion = this.venta.cliente.razon_social;
        asientoContableCobros.empresa_id = this.cobro.empresa_id;
        asientoContableCobros.usuario_id = this.cobro.usuario_id;
        asientoContableCobros.total = this.total_pago;
        asientoContableCobros.status = 'A';
		let valor_cheque= 0;
		let valor_tarjetas = 0;
		let valor_transferencias = 0;
		this.cheques.forEach(c=> {
			valor_cheque += Number(c.valor);
		});
		this.tarjetas.forEach(c=> {
			valor_tarjetas += Number(c.valor);
		});
		this.transferencias.forEach(c=> {
			valor_transferencias += Number(c.valor);
		});
        this.parametrosContabilidad.forEach(parametroContabilidad => {
            let asientoContableDetalle = new AsientoContableDetalle;
            asientoContableDetalle.empresa_id = asientoContableCobros.empresa_id;
			asientoContableDetalle.usuario_id = asientoContableCobros.usuario_id;
		
			if(parametroContabilidad.id == '14'){
                parametroContabilidad.tipo_saldo = "H";
                let total = this.venta.abonado==0?Number(this.total_pago)*0.88:this.total_pago;
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
            }
            
            if(parametroContabilidad.id == '6' && this.venta.abonado == 0){
                let total = Number(this.total_pago)*0.12;
                parametroContabilidad.tipo_saldo = "H";
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(total, this.numero_decimales):0;
				asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
				asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
                asientoContableDetalle.cuenta_contable_id = parametroContabilidad.cuenta_contable_id;
                asientoContableDetalle.cuenta = parametroContabilidad.cuentacontable;
			if( parametroContabilidad.id == "10" && this.valorefectivo > valor_cheque && this.valorefectivo > valor_tarjetas && this.valorefectivo > valor_transferencias ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if( parametroContabilidad.id == "11" && valor_cheque > this.valorefectivo && valor_cheque > valor_tarjetas && valor_cheque > valor_transferencias ) {
				
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if(  parametroContabilidad.id == "12" && valor_tarjetas > this.valorefectivo && valor_tarjetas > valor_cheque && valor_tarjetas > valor_transferencias ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
			else if( parametroContabilidad.id == "13"  && valor_transferencias > this.valorefectivo && valor_transferencias > valor_tarjetas && valor_transferencias > valor_cheque ) {
				asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}else if( parametroContabilidad.id == "10") {
                asientoContableDetalle.haber = parametroContabilidad.tipo_saldo=='H'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
			    asientoContableDetalle.debe = parametroContabilidad.tipo_saldo=='D'?this.utils.redondear(this.total_pago, this.numero_decimales):0;
                if(parametroContabilidad.tipo_saldo == 'H'){
                    asientoContableCobros.detalle.push(asientoContableDetalle);   
                }else{
                    asientoContableCobros.detalle.unshift(asientoContableDetalle);   
                }
			}
				
		});
        this.cobro.asientosContables.push(asientoContableCobros);
    }

    getPeriodoActual(){
        return new Promise((resolve, reject) => {
            let qs = "?periodo=" + moment().format('YYYY');
            this.periodoContableService.getPeriodoActual(qs).subscribe(
                res => {
                    this.periodoContable = res;
                    resolve(true);
                },
                err => {
                    reject(err);
                }
            );
        });
	}

    setValueEntity(){
        this.cobro.fecha_cobro = moment(this.fecha_cobro).format("YYYY-MM-DD");

        this.cobro.saldo = (this.tipo=="VE"?(this.venta.total - this.venta.abonado):(this.plan.total - this.plan.abonado));
        // this.cobro.saldo = (this.tipo=="VE"?(this.venta.total-this.venta.retencion.total):(this.plan.total));
        //this.cobro.saldo = this.venta.total - this.venta.abonado;
        this.cobro.recibido = this.total_pago;
        this.cobro.cambio = this.cambio;
        this.cobro.tipo_doc = (this.tipo=="VE"?"FAC":"PACUM");
        this.cobro.tipo_documento_id = (this.tipo=="VE"?this.venta.id:this.plan.id);
        //this.cobro.caja_id = this.ss.getData("caja_id");
        this.cobro.empresa_id = this.ss.getData("empresa_id");
        this.cobro.sucursal_id = this.ss.getData("sucursal_id");
        this.cobro.usuario_id = this.ss.getData("usuario_id");

        if( this.valorefectivo > 0 ){
            let cobro_detalle = new CobroDetalle();
            cobro_detalle.valor = this.valorefectivo;
            cobro_detalle.forma_pago_id = "1"; // EFECTIVO
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        }

        this.cheques.forEach(ch => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.fecha_cheque = ch.fecha;
            cobro_detalle.numero_cta = ch.cuenta;
            cobro_detalle.numero_cheque = ch.numero;
            cobro_detalle.banco_id = ch.banco_id;
            cobro_detalle.observacion = ch.observacion;
            
            cobro_detalle.valor = ch.valor;
            cobro_detalle.forma_pago_id = ch.forma_pago_id; // CHEQUE
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });

        this.tarjetas.forEach(tr => {
            let cobro_detalle = new CobroDetalle();

            cobro_detalle.debito_credito = tr.debito_credito;
            cobro_detalle.observacion = tr.observacion;
            cobro_detalle.tipo_tarjeta_id = tr.tipo_id;
            cobro_detalle.valor = tr.valor;
            cobro_detalle.plazo = tr.plazo;
            cobro_detalle.tiempo = tr.tiempo;
            cobro_detalle.forma_pago_id = tr.forma_pago_id; // TARJETA
            cobro_detalle.empresa_id = this.ss.getData("empresa_id");
            cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
            cobro_detalle.usuario_id = this.ss.getData("usuario_id");
            this.cobro.detalle.push(cobro_detalle);
        });

        this.transferencias.forEach(tr => {
			let cobro_detalle = new CobroDetalle();

			cobro_detalle.fecha_transferencia = tr.fecha;
			cobro_detalle.numero_cta = tr.cuenta;
			cobro_detalle.numero_comprobante = tr.numero;
			cobro_detalle.banco_id = tr.banco_id;
			cobro_detalle.observacion = tr.observacion;

			cobro_detalle.valor = tr.valor;
			cobro_detalle.forma_pago_id = tr.forma_pago_id; // TRANSFERENCIA
			cobro_detalle.empresa_id = this.ss.getData("empresa_id");
			cobro_detalle.sucursal_id = this.ss.getData("sucursal_id");
			cobro_detalle.usuario_id = this.ss.getData("usuario_id");
			this.cobro.detalle.push(cobro_detalle);
		});
        
    }

    onSubmit(){
        this.setValueEntity();
        if( this.Mod_Cartera && this.Mod_Contabilidad ){

            this.getPeriodoActual().then(
                res => {
                    this.setValueAsientoContable();
                       this.saveCobro();   
                }
            );
        }else {
           this.saveCobro();   
        }
    }

    saveCobro(){
        this.loading = true;
        this.cobroService.save(this.cobro).subscribe(
            res => { 
                //this.loading = false;
                this.msg.showMessage('success-message', res.message);
                //this.venta = new Venta();
                this.guardado = true;
                this.cobro = new Cobro();
                this.cobro_id = JSON.parse(res.response._body).id;
                this.cambio = 0;
                this.total_pago = 0;

                this.cheques = [];
                this.tarjetas = [];
                this.transferencias = [];
                this.valorefectivo = 0;

                this.datosPagos.total_cheque = 0;
                this.datosPagos.total_tarjeta = 0;
                this.datosPagos.total_efectivo = 0;
                this.datosPagos.total_transferencia = 0;
                this.getVenta().then(
                    res => this.loading = false,
                    err => this.loading = false
                );

            },
            err => {
                this.loading = false;
                this.msg.showMessage('error-message',err);
            }
        );
    }

    onChangeEfectivo(total){
        this.valorefectivo = total;
        this.is_change_efectivo = true;
        
    }

    calcSaldo(venta){
        let saldo = venta.total - venta.abonado;

        if( venta.retencion ){
            saldo = saldo - venta.retencion.total;
        }
        //return saldo = Math.round(saldo * 100) / 100;
        return saldo = this.utils.redondear(saldo, this.numero_decimales);
    }

    calcularTotal(total){
        this.total_pago = total;

        let saldo = 0;

        if( this.tipo == "VE" ){
            //CALCULAR CAMBIO
            saldo = this.venta.total - this.venta.abonado;

            if( this.venta.retencion ){
                saldo = saldo - this.venta.retencion.total;
            }
        }else{
            saldo = this.plan.total - this.plan.abonado;
        }

        this.cambio = (this.total_pago > saldo?(this.total_pago - saldo):0);
        //this.cambio = Math.round( this.cambio * 100) / 100;
        this.cambio = this.utils.redondear(this.cambio, this.numero_decimales);
    }

    getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.datosPagos.numero_decimales = this.numero_decimales;
                    this.datosPagos.setFormat();
                    
                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
	}
	
	get formatDecimal(){
        return this.format_decimal;
    }

    openModalCuotas(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template);
    }

    getEstadoCuota(estado){
        return (estado=="PE"?"PENDIENTE":"COBRADO");
    }

    onSelectRow(detalle, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de producto
        this.valorefectivo = this.utils.redondear(detalle.saldo, this.numero_decimales);
        this.total_pago = this.valorefectivo;this.total_pago = this.valorefectivo;
	}

	onDBLClick(detalle,i)
	{
        this.onSelectRow(detalle,i);
        this.bsModalRef.hide();
		// this.onSubmit();
    }
    
    cancelarCuota(){
        this.valorefectivo = 0;
        this.bsModalRef.hide();
    }
    getDiasRestantes(detalle){
        let fecha_vencimiento = moment(detalle.fecha_vencimiento);
        return fecha_vencimiento.diff(moment(), 'days')
    }

    getListadoAbonos(){
        this.abonos = [];
        if( this.tipo == "VE" ){
            this.venta.grupo.forEach((item: any) => {
                this.abonos.push({
                    cobro_id: item.cobro.id,
                    fecha_cobro: item.cobro.fecha_cobro,
                    valor: Number(item.cobro.recibido) - Number(item.cobro.cambio)
                });
            });
        }else{
            this.plan.grupo.forEach((item: any) => {
                this.abonos.push({
                    cobro_id: item.cobro.id,
                    fecha_cobro: item.cobro.fecha_cobro,
                    valor: Number(item.cobro.recibido) - Number(item.cobro.cambio)
                });
            });
        }
    }

    anularCobro(cobro){
		let preg = "¿Está seguro de querer anular el cobro?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				
				this.loading = true;

				this.cobroService.anular(cobro).subscribe(
					res => {
						this.bsModalRef.hide();
						

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getVenta().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}

    imprimirComprobante(){
        let params = [];        
        params["empresa_id"] = this.ss.getData('empresa_id');
        params["usuario_id"] = this.ss.getData('usuario_id');
		if(this.tipo){
		
			params["tipo"] = this.tipo;
		}
        if (this.tipo == "VE") {
            if(this.venta.cliente_id){
		
                params["cliente_id"] = this.venta.cliente_id;
            }
        }else{
            if(this.plan.cliente_id){
		
                params["cliente_id"] = this.plan.cliente_id;
            }
        }
		if(this.cobro_id){
			params["cobro_id"] = this.cobro_id;
		}
	
		

        let qs = [];
        for(let key in params){
            let str = key + "=" + params[key];
            qs.push(str);
        }
		
		const initialState = { route: "cobro", qs: "?" + qs.join("&") + "&dbname=" + this.ss.getData('dbname') };
        this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
    }

    onPrint(cobro_id){
     
        let params = [];        
        params["empresa_id"] = this.ss.getData('empresa_id');
        params["usuario_id"] = this.ss.getData('usuario_id');


		if(this.tipo){
		
			params["tipo"] = this.tipo;
        }
        if (this.tipo == "VE") {
            if(this.venta.cliente_id){
		
                params["cliente_id"] = this.venta.cliente_id;
            }
        }else{
            if(this.plan.cliente_id){
		
                params["cliente_id"] = this.plan.cliente_id;
            }
        }
		
		if(cobro_id){
			params["cobro_id"] = cobro_id;
		}
	
		

        let qs = [];
        for(let key in params){
            let str = key + "=" + params[key];
            qs.push(str);
        }
		
		const initialState = { route: "cobro", qs: "?" + qs.join("&") + "&dbname=" + this.ss.getData('dbname') };
        this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
    }
    imprimir(){
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/cobro-add/cobro-add.component.ts